import { Injectable, inject } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map } from 'rxjs/operators';

import EduCoursesTariffsActions from './edu-courses-tariffs.actions';
import { EduCoursesTariffsHttpService } from './edu-courses-tariffs.http.service';
import AppActions from '@web/store/app/app.actions';

@Injectable()
export class EduCoursesTariffsEffect {
    private readonly actions$ = inject(Actions);
    private readonly eduCoursesTariffsHttpService = inject(EduCoursesTariffsHttpService);

    public readonly loadEduCoursesTariffsRequest$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AppActions.initAppSuccess),
            exhaustMap(() =>
                this.eduCoursesTariffsHttpService.getEduCoursesTariffs().pipe(
                    map((tariffs) => EduCoursesTariffsActions.loadCollectionSuccess({ tariffs })),
                    catchError((error) => [EduCoursesTariffsActions.loadCollectionFailure({ error })])
                )
            )
        )
    );
}
